import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { ApartmentEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Component, Input } from '@angular/core';

import { ProductLoadingScreen } from './product-loading-screen';

@Component({
  selector: 'app-apartment-loading-screen',
  templateUrl: './apartment-loading-screen.component.html',
  styleUrls: [],
  standalone: false
})
export class ApartmentLoadingScreenComponent extends ProductLoadingScreen<ApartmentEnterpriseSearchInterface> {
  @Input() animated = true;
  constructor(service: EnterpriseSearchService) {
    super(service, service.searches[ServiceType.LongStays]);
  }
}
